import { required } from '@vuelidate/validators'

export const ClientValidation = {
    name: { required },
    redirect: { required },
    scopes: { required },
}
